module.exports = __webpack_public_path__ + "img/avatar.fe23443d.png";